import React from "react"
import {Mutation as ApolloMutation, MutationProps} from "react-apollo"

import {getErrorMessage} from "../../lang/formatError"

export interface MutationComponentProps extends MutationProps {}

const Mutation: React.FC<MutationComponentProps> = ({children, ...props}) => {
  return (
    <ApolloMutation {...props}>
      {(mutation, apollo) => children((...args) => mutation(...args), {...apollo, errorMsg: getErrorMessage(apollo.error)})}
    </ApolloMutation>
  )
}

export default Mutation
